import React, { useState } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import ApiConnectionsSidebar from "../../components/apis/ApiConnectionSidebar";

const SailPartnerHub = () => {
    const [windows, setWindows] = useState([]);

    // Open a new browser window and track it
    const openBrowserWindow = (url, title) => {
        const newWindow = window.open(
            url,
            title,
            "width=600,height=400,left=100,top=100,resizable=yes"
        );

        const windowObject = {
            id: Date.now(),
            windowRef: newWindow,
            url,
            title,
            isFullscreen: false,
        };

        setWindows([...windows, windowObject]);
    };

    // Close the browser window and remove it from state
    const handleCloseWindow = (id) => {
        const targetWindow = windows.find((win) => win.id === id);
        if (targetWindow && targetWindow.windowRef) {
            targetWindow.windowRef.close(); // Close the actual browser window
        }
        setWindows(windows.filter((win) => win.id !== id)); // Remove from state
    };

    // Toggle fullscreen by resizing the window dynamically
    const toggleFullScreenWindow = (id) => {
        setWindows(
            windows.map((win) => {
                if (win.id === id) {
                    const isCurrentlyFullscreen = win.isFullscreen;

                    if (win.windowRef && !win.windowRef.closed) {
                        try {
                            if (isCurrentlyFullscreen) {
                                // Restore to default size
                                setTimeout(() => {
                                    win.windowRef.resizeTo(600, 400);
                                    win.windowRef.moveTo(100, 100);
                                }, 0);
                            } else {
                                // Maximize to fullscreen
                                setTimeout(() => {
                                    win.windowRef.resizeTo(window.screen.width, window.screen.height);
                                    win.windowRef.moveTo(0, 0);
                                }, 0);
                            }
                        } catch (error) {
                            console.error("Error resizing window:", error);
                        }
                    }

                    return { ...win, isFullscreen: !isCurrentlyFullscreen };
                }
                return win;
            })
        );
    };

    return (
        <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
            {/* API Connections Sidebar */}
            <Box sx={{ width: "250px", borderRight: "1px solid lightgrey" }}>
                <ApiConnectionsSidebar />
            </Box>

            {/* Main Content Area */}
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", padding: "20px", overflow: "hidden" }}>
                <Box sx={{ marginBottom: 2 }}>
                    <Typography variant="h4">Sail Partner Hub</Typography>
                </Box>

                {/* Display list of open windows */}
                <Box sx={{ marginTop: 3 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2 }}>
                        Open Browser Windows:
                    </Typography>
                    {windows.map((win) => (
                        <Box
                            key={win.id}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "8px",
                                marginBottom: "8px",
                            }}
                        >
                            <Typography sx={{ flexGrow: 1, fontWeight: "bold" }}>{win.title}</Typography>
                            <Tooltip title="Fullscreen / Restore" placement="top">
                                <IconButton onClick={() => toggleFullScreenWindow(win.id)} aria-label="toggle fullscreen">
                                    <FullscreenIcon sx={{ color: "navy" }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Window" placement="top">
                                <IconButton onClick={() => handleCloseWindow(win.id)} aria-label="close window">
                                    <CloseIcon sx={{ color: "red" }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default SailPartnerHub;
